package music.jammers.client.shared.signin.models

data class GoogleAuthError(
    val code: Long,
    val description: String,
)